import { render, staticRenderFns } from "./Asignaciones.vue?vue&type=template&id=48f4c522&"
import script from "./Asignaciones.vue?vue&type=script&lang=js&"
export * from "./Asignaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports